import React, { createContext, useContext, useState, useEffect } from 'react';
import { isAuthenticated, setApiKey, clearApiKey } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 检查本地存储的登录状态
    const authStatus = isAuthenticated();
    setAuthenticated(authStatus);
    setLoading(false);
  }, []);

  const login = (apiKey) => {
    setApiKey(apiKey);
    setAuthenticated(true);
  };

  const logout = () => {
    clearApiKey();
    setAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ authenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth 必须在 AuthProvider 内使用');
  }
  return context;
};

export default AuthContext;
